import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
//import { PlatformGroupRoleService } from 'projects/shared/src/lib/services/platform-group-role.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'app-add-tenant-grouprole-dialog',
  templateUrl: './add-tenant-grouprole-dialog.component.html',
  styleUrls: ['./add-tenant-grouprole-dialog.component.css']
})
export class AddTenantGrouproleDialogComponent implements OnInit {

  groupRoleForm!: FormGroup;
  titleAlert: string = 'This field is required';


  constructor(
    private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<AddTenantGrouproleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService

  ) {

  }
   ngOnInit(): void {
    this.createUserForm();
  }
  createUserForm() {
    this.groupRoleForm = this.formBuilder.group({
      name: [null, Validators.required],
      permissions: ['']
    });
  }

  onChange(permissions: string) {
    this.groupRoleForm.get('permissions')!.setValue(permissions);
  }
  cancel() {
    this._dialogRef.close();
  }

  add() {
    if (this.groupRoleForm.valid) {
      console.log(this.groupRoleForm.value)
      this._dialogRef.close(this.groupRoleForm.value);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }


}

